import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { trackPageView } from "@/lib/analytics";
import Home from "@/pages/Home";
import PublicPromise from "@/pages/PublicPromise";
import Confirm from "@/pages/Confirm";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Termini from "@/pages/Termini";
import Contatti from "@/pages/Contatti";
import Segnala from "@/pages/Segnala";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

function App() {
  return (
    <div className="App grain">
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#161412",
            border: "1px solid #2A2622",
            color: "#F2EFE9",
            borderRadius: "2px",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/promessa/:numero" element={<PublicPromise />} />
          <Route path="/conferma" element={<Confirm />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/termini" element={<Termini />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/segnala" element={<Segnala />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
